import mangoStore from '@store/mangoStore'
import { useMemo } from 'react'
import { breakpoints } from 'utils/theme'

/**
 *
 * @deprecated use useBreakpoints
 */
export const useViewport = () => {
  const width = mangoStore((s) => s.window.width)
  const height = mangoStore((s) => s.window.height)

  const [tempMobile, isMobile, isTablet, isDesktop] = useMemo(() => {
    if (!width) {
      return [false, false, false]
    }
    const tempMobile = width < breakpoints.sm
    const mobile = width < breakpoints.md
    const tablet = width >= breakpoints.md && width < breakpoints.lg
    const desktop = width >= breakpoints.lg
    return [tempMobile, mobile, tablet, desktop]
  }, [width])

  return { width, height, isMobile, isTablet, isDesktop, tempMobile }
}
